import { render, staticRenderFns } from "./BreadCumbWrapper.vue?vue&type=template&id=5704213c&"
import script from "./BreadCumbWrapper.vue?vue&type=script&lang=js&"
export * from "./BreadCumbWrapper.vue?vue&type=script&lang=js&"
import style0 from "./BreadCumbWrapper.vue?vue&type=style&index=0&id=5704213c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports